import { days_label, type Panel } from "../vendor/web";

/** Adding DR here would make the strip repeat the diagram it sits under. */
export function pinnedStrip(panel: Panel): HTMLElement {
  const strip = document.createElement("div");
  strip.className = "pin";
  strip.append(
    field("Budget", days_label(panel.remaining_days), panel.overspent),
    field("Weight", `${trim(panel.carried_weight)} lb`),
    field("Move", String(panel.move)),
    field("Dodge", String(panel.dodge)),
    field("Enc.", panel.encumbrance),
  );
  return strip;
}

function field(label: string, value: string, over = false): HTMLElement {
  const wrapper = document.createElement("div");
  wrapper.className = over ? "pin-field pin-field-over" : "pin-field";
  const name = document.createElement("span");
  name.className = "pin-label";
  name.textContent = label;
  const reading = document.createElement("span");
  reading.className = "pin-value";
  reading.textContent = value;
  wrapper.append(name, reading);
  return wrapper;
}

function trim(pounds: number): string {
  return Number.isInteger(pounds) ? String(pounds) : pounds.toFixed(2);
}
